/**
 * @license
 * Copyright UX Stack. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at LICENSE.md
 */

import * as uxstackpb from '@uxstack/sdk-proto-js/uxstack/sdk/v1/sdk_pb';
import { EventPayload } from './payload';

export class TrackPayload extends uxstackpb.TrackPayload implements EventPayload {
  public toPayload(): typeof uxstackpb.EventMessage.prototype.payload {
    return {
      case: 'track',
      value: this,
    };
  }
}
